
export const productData = [
  {
    img: `${process.env.PUBLIC_URL}/mintPics/format17.jpg`,
    alt: 'Single Room',
    name: 'Single Room',
    desc:
      'This is a perfect space for single occupancy with a double wardrobe, study desk, shared bathroom and plenty of storage. ',
    pricing: 'Ksh 10,000 pp/pm',
    button: 'Make reservation',
    isReverse: true
  },
  {
    img: `${process.env.PUBLIC_URL}/mintPics/format18.jpg`,
    alt: 'Double Room',
    name: 'Double Room',
    desc:
      'This is perfect for sharing with a friend or relative and includes a fitted wardrobe, study desks and lots of storage.',
    pricing: 'Ksh 7,500 pp/pm',
    button: 'Make reservation',
    isReverse: true
  },
  {
    img: `${process.env.PUBLIC_URL}/mintPics/format23.jpg`,
    alt: 'short-stay',
    name: 'Four Sharing Room',
    desc:
      ' We offer a variety of comfortable and affordable options for travelers looking for a place to stay for a night or a few days',
    pricing: 'Ksh 5000 pp/pm',
    button: 'Make reservation',
    isReverse: true
  },

];
